import React from "react";

/**
 * Spinning brutalist rosette sticker. Customisable label, number, accent.
 */
const ROSETTE_CLIP =
  "polygon(50% 0%, 60% 8%, 70% 4%, 78% 14%, 88% 12%, 92% 24%, 100% 30%, 96% 40%, 100% 50%, 96% 60%, 100% 70%, 92% 76%, 88% 88%, 78% 86%, 70% 96%, 60% 92%, 50% 100%, 40% 92%, 30% 96%, 22% 86%, 12% 88%, 8% 76%, 0% 70%, 4% 60%, 0% 50%, 4% 40%, 0% 30%, 8% 24%, 12% 12%, 22% 14%, 30% 4%, 40% 8%)";

const Rosette = ({
  topLabel = "shipped for",
  big = "03",
  bottomLabel = "studios",
  size = 256,
  outer = "#ff2a8f",
  bigColor = "#fff",
  textColor = "#c8ff2a",
  className = "",
}) => (
  <div
    className={`relative flex items-center justify-center ${className}`}
    style={{
      width: size,
      height: size,
      background: outer,
      clipPath: ROSETTE_CLIP,
      animation: "ggl-spin 20s linear infinite",
    }}
  >
    <div
      className="absolute inset-2 flex flex-col items-center justify-center text-center font-black uppercase"
      style={{
        background: "#060606",
        color: textColor,
        clipPath: ROSETTE_CLIP,
        fontFamily: "'Azeret Mono', monospace",
      }}
    >
      <div className="text-[11px] tracking-[0.4em]">{topLabel}</div>
      <div className="text-6xl mt-1" style={{ color: bigColor }}>
        {big}
      </div>
      <div className="text-[11px] tracking-[0.32em] mt-1">{bottomLabel}</div>
    </div>
  </div>
);

export default Rosette;
